import { render, staticRenderFns } from "./Associate.vue?vue&type=template&id=5c3d20e4&scoped=true&"
import script from "./Associate.vue?vue&type=script&lang=ts&"
export * from "./Associate.vue?vue&type=script&lang=ts&"
import style0 from "./Associate.vue?vue&type=style&index=0&id=5c3d20e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d20e4",
  null
  
)

export default component.exports